import { useRequest } from 'ahooks';
import { isNil } from 'lodash-es';
import { useTranslate } from '@tolgee/react';
import {
  getDepartmentDetail,
  getDepartmentNoReceptionStoreList,
  listDepartmentAndRoles,
  listDepartments,
} from 'services/api/department/department';
import { getNewPermissionsV2 } from 'services/api/department/permissions';
import { getReceptionRolesList } from 'services/api/department/roleWithDepartment';
import { errorToasterWithServerMsg } from 'utils/errorToaster';

const cacheKeyGen = (key: string, prefix = '@@useDepartmentsDatas') => `${prefix}_${key}`;
interface Department extends StoreHomeV2.Department {}

export const useAllPermissionsV2 = () =>
  useRequest(() => getNewPermissionsV2(), {
    cacheKey: cacheKeyGen('useAllPermissionsV2'),
  });

export const useDepartmentAndRolesList = () => {
  const { t } = useTranslate();
  const request = useRequest(
    async () => {
      const data = await listDepartmentAndRoles();
      return data;
    },
    {
      onError: (err) => {
        errorToasterWithServerMsg(err, t('department.获取部门角色信息错误，请稍后再试'));
      },
      cacheKey: cacheKeyGen('@@useDepartmentAndRolesList'),
    },
  );
  return request;
};

export const useDepartmentList = () => {
  return useRequest(
    () => {
      return listDepartments().then((r) => r.data.data.departments);
    },
    { cacheKey: cacheKeyGen('useDepartmentLists') },
  );
};
/**
 * 获取部门详情
 * @param id  部门id
 * @returns
 */
export const useDepartmentDetailOfId = (id?: Department['id']) => {
  const { t } = useTranslate();
  return useRequest(() => getDepartmentDetail(id), {
    cacheKey: cacheKeyGen(`useDepartmentDetailOfId_${id}`),
    ready: !isNil(id),
    refreshDeps: [id],
    onError: (err) => {
      errorToasterWithServerMsg(err, t('department.获取部门详情失败，请稍后再试'));
    },
  });
};

export const useNoReceptionStoreOfDept = (id?: Department['id']) => {
  return useRequest(
    () => {
      return getDepartmentNoReceptionStoreList(id!).then((r) => r.data.data);
    },
    {
      cacheKey: cacheKeyGen(`useNoReceptionStoreOfDept${id}`),
      ready: !isNil(id),
      refreshDeps: [id],
    },
  );
};
export const useReceptionRolesOfDept = (deparmentId: StoreHomeV2.Department['id']) => {
  return useRequest(
    () => {
      return getReceptionRolesList(deparmentId).then((r) => r.roles);
    },
    {
      cacheKey: cacheKeyGen(`useReceptionRolesOfDept_${deparmentId}`),
      // staleTime: 1000 * 60 * 1.5,
      // cacheTime: 1000 * 60 * 2,
    },
  );
};
